
import { cn } from "@/lib/utils";
import { FilmStatus } from "@/types/inventory";
import { useTranslation } from "@/hooks/useTranslation";

interface FilmStatusBadgeProps {
  status: FilmStatus;
  className?: string;
}

export function FilmStatusBadge({ status, className }: FilmStatusBadgeProps) {
  const { t } = useTranslation();
  
  // Get appropriate styling based on status
  const getStatusStyle = (status: FilmStatus) => {
    switch(status) {
      case 'fresh': return 'bg-emerald-900 text-emerald-100';
      case 'expired': return 'bg-purple-900 text-purple-100';
      case 'exposed': return 'bg-rose-900 text-rose-100';
      case 'developed': return 'bg-blue-900 text-blue-100';
      default: return 'bg-emerald-900 text-emerald-100';
    }
  };

  return (
    <span className={cn(`inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-medium min-w-[70px] ${getStatusStyle(status)}`,
      className
    )}>
      {t(status)}
    </span>
  );
}
